import {
  ACCOUNT_NOTIFICATION,
  ACCOUNT_NOTIFICATION_TABLE,
  NOTIFICATION_API,
} from "../actions/types";

const initialState = {
  notifications: [],
  notificationsTable: [],
  notificationsApi: false,
};

const notificationReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ACCOUNT_NOTIFICATION:
      return {
        ...state,
        notifications: payload,
      };
    case ACCOUNT_NOTIFICATION_TABLE:
      return {
        ...state,
        notificationsTable: payload,
      };
    case NOTIFICATION_API:
      return {
        ...state,
        notificationsApi: payload,
      };
    default:
      return state;
  }
};

export default notificationReducer;
